import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import CustomFormInput from '../CustomFormInput'
import { SkillValidation } from '../../validate/skillValidation';
import ErrorFilter from '../../helper/errorFilter';
import { addSkill, editSkill } from '../../controller';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { requestHandler } from '../../helper';
import SingleError from '../../helper/SingleError';

function AddSkillModal({ show, getSkillData, setAddSkill, skillData, id, setId, setSelectedSkill, page }) {
  // const baseUrl = process.env.REACT_APP_BASE_URL
  const requiredField = ["name"];
  const [errors, setErrors] = useState({});
  // const [imagePreview, setImagePreview] = useState(null);


  const [submitCount, setSubmitCount] = useState(0);
  // const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const handleClose = () => {
    setAddSkill(false);
    setId(null);
    setSelectedSkill({})
    if (!skillData) {
      setSkill({ name: "", skill_image: "" });
    }
    setErrors({});
    // setImagePreview(null);
  }
  const [skill, setSkill] = useState({
    name: skillData?.name || "",
    skill_image: skillData?.image || "",
  })

  useEffect(() => {
    if (skillData) {
      setSkill({
        name: skillData.name,
        skill_image: skillData.image,
      });
      // setImagePreview(skillData.skill_image || null);  // If skill_image exists, set preview
    }
  }, [skillData]);


  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (submitCount > 0) {
      let validationError = SkillValidation({
        ...skill,
        [name]: value
      });
      validationError = ErrorFilter(validationError, requiredField);
      setErrors(validationError);
      if (Object.keys(validationError).length === 0) {
        delete errors[name];
      }
    }

    if (files && files.length > 0) {
      const file = files[0];
      const newCategoryData = {
        ...skill,
        [name]: file,  // Ensure the file itself is being passed, not the file path
      };
      // const previewUrl = URL.createObjectURL(file);
      // setImagePreview(previewUrl); // Set the preview URL

      let validationError = SkillValidation(newCategoryData);
      validationError = ErrorFilter(validationError, requiredField);
      setErrors(validationError);
      if (Object.keys(validationError).length === 0) {
        delete errors[name];
      }
      setSkill(newCategoryData);
    } else {
      setSkill({ ...skill, [name]: value });
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSubmitCount(prevCount => prevCount + 1);
    const updateValues = { ...skill };
    let validationErrors = SkillValidation(updateValues);
    validationErrors = ErrorFilter(validationErrors, requiredField);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      const formData = new FormData();
      formData.append("name", updateValues.name);

      // // Ensure you are appending the actual file object here
      // if (updateValues.skill_image) {
      //   formData.append("skill_image", updateValues.skill_image);  // This should be a File object
      // }

      await requestHandler(
        async () => {
          if (id) {
            return await editSkill(formData, id);
          } else {
            return await addSkill(formData);
          }
        },
        null,
        (res) => {
          toast.success(res.message);
          navigate("/category-management");
          getSkillData(page);
          handleClose();
        },
        () => { }
      );
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>{skillData?._id ? "Edit Skill Level" : "Add New Skill Level"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CustomFormInput
          type="text"
          label="Skill Title"
          placeholder="Enter skill title"
          id="name"
          name="name"
          value={skillData?._id && skill.name}
          onChange={handleChange}
        />
        <SingleError error={errors.name} />
        {/* <div className='theme-input'>
          <Form.Label htmlFor="skill_image">Skill Symbol</Form.Label> */}
        {/* <Form.Label htmlFor="skill_image" className='skill-symbol'>
            <div className='upload-icon'>
              <img src="/images/svg/upload.svg" alt="icon" />
            </div>
            <p className='fs-14 fw-400 text-primary text-decoration-underline mb-0'>Select your file</p>
            <Form.Control type="file" id="skill_image" name="skill_image" onChange={handleChange}></Form.Control>
            <SingleError error={errors.skill_image} />
          </Form.Label> */}
        {/* Image Preview */}
        {/* {imagePreview && ( */}
        {/* <div className="image-preview">

            <img
              src={imagePreview !== null
                ? imagePreview
                : (skillData.image ? baseUrl + skillData.image : '/logo192.png')}
              alt="Preview"
              className="img-thumbnail"
            />
          </div> */}

        {/* )} */}

        {/* </div> */}
        <div className="d-sm-flex align-items-center gap-sm-4 gap-2">
          <button onClick={handleClose} className="btn btn-outline-light w-100">
            Cancel
          </button>
          <button className="btn btn-primary w-100 mt-sm-0 mt-2" type="button" onClick={handleSave}>
            {skillData ? "Save Changes" : "Add New Skill"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AddSkillModal